import * as types from './constants';

const initialState = {
  isFetchingLogin: false,
  user: null,
  loginError: null,
  flashMessage: null,
  consecutiveCredentialFailures: 0
};
const appReducer = (state = initialState, action) => {

  switch (action.type) {

    case types.REQUEST_LOGIN:
      return {
        ...state,
        isFetchingLogin: true
      };

    case types.RECEIVE_LOGIN:
      return {
        ...state,
        isFetchingLogin: false,
        user: action.user,
        loginError: null,
        consecutiveCredentialFailures: 0
      };

    case types.RECEIVE_LOGIN_ERROR: {
      const isCredentialError = !!action.isCredentialError;
      const previousCredentialFailureCount = Number.isFinite(state.consecutiveCredentialFailures)
        ? state.consecutiveCredentialFailures
        : 0;
      const credentialFailureCount = isCredentialError
        ? previousCredentialFailureCount + 1
        : 0;
      const loginError = isCredentialError && credentialFailureCount >= 2
        ? types.POSSIBLE_PASSWORD_EXPIRED_ERROR
        : action.error;

      return {
        ...state,
        isFetchingLogin: false,
        loginError,
        consecutiveCredentialFailures: credentialFailureCount
      };
    }

    case types.RESET_LOGIN_ERROR:
      return {
        ...state,
        loginError: null
      };

    case types.SHOW_FLASH_MESSAGE:
      return {
        ...state,
        flashMessage: {
          message: action.message,
          type: action.messageType
        }
      };

    case types.HIDE_FLASH_MESSAGE:
      return {
        ...state,
        flashMessage: null
      };

    default: return state;
  }
};

export default appReducer;
